import CheckCircleIcon from '@heroicons/react/outline/esm/CheckCircleIcon.js'
import DocumentTextIcon from '@heroicons/react/outline/esm/DocumentTextIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { staticFieldsFactory as postsListStaticFieldsFactory } from '../PostsBlock/config.js'
import { StaticField } from '../Views/types.js'
import { SinglePostBlockProps } from './types.js'

export const staticFieldsFactory: (intl: I18nShape) => StaticField[] = intl => [
  ...postsListStaticFieldsFactory(intl),
  {
    id: 'pinnedReply',
    label: intl.$t({
      defaultMessage: 'Pinned reply',
      id: 'Generics.PinnedReply',
    }),
    enabled: false,
    locked: false,
    styles: ['card'],
    settings: {},
    isStatic: true,
    icon: <CheckCircleIcon />,
    default:
      '<p>Commodo <b>magna esse</b> ea in in. Minim <i>occaecat</i> aute <a>veniam pariatur</a> laboris veniam.</p>',
  },
]

export const SinglePostConfig: (intl: I18nShape) => {
  defaultProps: SinglePostBlockProps
  displayName: string
  removable: boolean
  Icon: JSX.Element
} = ({ $t }) => ({
  defaultProps: {
    postId: '',
    fields: [],
  },
  displayName: $t({
    defaultMessage: 'Single post',
    id: 'Blocks.SinglePost.DisplayName',
  }),
  removable: true,
  Icon: <DocumentTextIcon />,
})
